import type { Modifier, State } from '@popperjs/core';

export const sameWidthModifier: Modifier<'sameWidth', Record<string, unknown>> = {
    name: 'sameWidth',
    enabled: true,
    phase: 'beforeWrite',
    requires: ['computeStyles'],
    fn: ({ state }: { state: State }) => {
        state.styles.popper.width = `${state.rects.reference.width}px`;
    },
    effect: ({ state }: { state: State }) => {
        state.elements.popper.style.width = `${
            (state.elements.reference as HTMLElement).offsetWidth
        }px`;
    },
};
